/**
 * Autore: Salvo de Luca
 * Azienda: Dialogicom s.r.l.s.
 * File: src/components/modular-form/custom/SocialCheckboxRow.tsx
 * Release: 1.0.0
 * Descrizione: Checkbox WhatsApp e Telegram allineate a destra in una riga
 */

import React from 'react';
import { WhatsAppIcon, TelegramIcon } from '../icons';

interface SocialCheckboxRowProps {
  value?: { whatsapp?: boolean; telegram?: boolean };
  onChange: (value: { whatsapp: boolean; telegram: boolean }) => void;
  disabled?: boolean;
}

const SocialCheckboxRow: React.FC<SocialCheckboxRowProps> = ({ value = {}, onChange, disabled }) => {
  return (
    <div className="flex w-full justify-end gap-6">
      <label className="flex items-center text-xs text-zinc-300">
        <input
          type="checkbox"
          checked={!!value.whatsapp}
          onChange={e => {
            console.log('🔧 [SocialCheckboxRow] WhatsApp onChange:', {
              value: e.target.checked,
              timestamp: new Date().toISOString()
            });
            onChange({ whatsapp: e.target.checked, telegram: value.telegram ?? false });
          }}
          onClick={(e) => {
            console.log('🔧 [SocialCheckboxRow] WhatsApp onClick:', {
              type: e.type,
              target: (e.target as HTMLElement).tagName,
              timestamp: new Date().toISOString()
            });
          }}
          disabled={disabled}
          className="h-4 w-4 border-zinc-600 rounded bg-zinc-700 checked:bg-green-600 checked:border-green-500 focus:ring-green-500 focus:ring-2"
        />
        <span className="ml-2 flex items-center">
          <WhatsAppIcon className="w-4 h-4 mr-1" /> WhatsApp
        </span>
      </label>
      <label className="flex items-center text-xs text-zinc-300">
        <input
          type="checkbox"
          checked={!!value.telegram}
          onChange={e => {
            console.log('🔧 [SocialCheckboxRow] Telegram onChange:', {
              value: e.target.checked,
              timestamp: new Date().toISOString()
            });
            onChange({ whatsapp: value.whatsapp ?? false, telegram: e.target.checked });
          }}
          onClick={(e) => {
            console.log('🔧 [SocialCheckboxRow] Telegram onClick:', {
              type: e.type,
              target: (e.target as HTMLElement).tagName,
              timestamp: new Date().toISOString()
            });
          }}
          disabled={disabled}
          className="h-4 w-4 border-zinc-600 rounded bg-zinc-700 checked:bg-green-600 checked:border-green-500 focus:ring-green-500 focus:ring-2"
        />
        <span className="ml-2 flex items-center">
          <TelegramIcon className="w-4 h-4 mr-1" /> Telegram
        </span>
      </label>
    </div>
  );
};

export default SocialCheckboxRow; 